// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t9Acs","col":"styles_col___3EB9"};